import React from 'react'
import ProdIOOOmrAddRow from './ProdIOOOmrAddRow'
import FormLabel from '../../../../../library/form/components/FormLabel';
import withView from '../../../../cmn/docAutomation/withView';
import SarasTrans from '../../../../../library/notifications/SarasTrans';
import FormWrapper from "../../../../../library/form/components/FormWrapper";
import FormDialog from '../../../../../library/form/components/FormDialog';
import { UiView, UiViewContent } from "../../../../../library/layout/Index";

const ProdIOOOmrAdd = (props) => {
    const { formObject, viewData, ...restProps } = props;

    return (
        <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true} formObject={formObject}
            action={{ formActions: { forAction: "Confirm", forCancel: "Cancel", confirmAction:"Are you sure to Confirm ?", confirmCancel:"Are you sure to Cancel ?" }, 
            actionParam: {actionType:"returnRMOutput", pathKey:"OOMR"} }}
            formStyle={{ width: '950px', height: '450px' }}
            contentStyle={{ height: '300px' }}
            formTitle={<SarasTrans value='Return SF Output' />}
            >
            <UiView>
                <UiViewContent>
                    <ul className="uiListTable">
                        <li className="uiSearchHeading">
                            <ul>
                                <li className="uiColumnCenter uiColumn30"><SarasTrans value="Sr No." /></li>
                                <li className="uiColumnCenter uiColumn70"><SarasTrans value="Item Id" /></li>
                                <li className="uiColumnCenter uiColumn150"><SarasTrans value="Item Name" /></li>
                                <li className="uiColumnCenter uiColumn30"><SarasTrans value="Unit" /></li>
                                <FormWrapper customWrapper="li" formObject={formObject} wrapperClass="uiColumnCenter uiColumn50" headerKey="viewConfig"
                                    action={{ paramName: "variation1Name" }} >
                                    <FormLabel formObject={formObject} headerKey="viewConfig" action={{ paramName: "variation1Name" }} value="Variation 1" />
                                </FormWrapper>
                                <FormWrapper customWrapper="li" formObject={formObject} wrapperClass="uiColumnCenter uiColumn50" headerKey="viewConfig"
                                    action={{ paramName: "variation2Name" }} >
                                    <FormLabel formObject={formObject} headerKey="viewConfig" action={{ paramName: "variation2Name" }} value="Variation 2" />
                                </FormWrapper>
                                <li className="uiColumnCenter uiColumn70"><SarasTrans value="Available Qty" /></li>
                                <li className="uiColumnCenter uiColumn150"><SarasTrans value="Return Qty" /></li>
                                <FormWrapper formObject={formObject} wrapperClass="" headerKey="viewConfig"
                                    action={{ paramName: "showCost" }} >
                                    <li className="uiColumnCenter uiColumn70"><SarasTrans value="Item Unit Cost" /></li>
                                    <li className="uiColumnCenter uiColumn70"><SarasTrans value="Labor Unit Cost" /></li>
                                    <li className="uiColumnCenter uiColumn70"><SarasTrans value="OH Unit Cost" /></li>
                                    <li className="uiColumnCenter uiColumn70"><SarasTrans value="Total Unit Cost" /></li>
                                </FormWrapper>
                                <FormWrapper customWrapper="li" formObject={formObject} wrapperClass="uiColumnCenter uiColumn50" headerKey="viewConfig"
                                    action={{ paramName: "showAIC" }} >
                                    <SarasTrans value="Absorb Cost" />
                                </FormWrapper>
                            </ul>
                        </li>
                        {
                            Object.values(viewData ? viewData : {}).map((row, index) => (
                                <li><ProdIOOOmrAddRow formObject={formObject} rowKey={row.rowKey} viewData={row} key={index} index={index + 1} /></li>
                            ))
                        }
                    </ul>
                </UiViewContent>
            </UiView>
            </FormDialog>
    )
}

export default withView(ProdIOOOmrAdd, "prodIOAddOOMR", "prodIOEOGroup");
